import React from 'react';
import './Intro.css';
import yo from '../../img/yo.png'

function Intro() {
    return (
        <div className="i">
            <div className="i-left">
                <div className="i-left-wrapper">
                    <h2 className="i-intro">Hello! My name is</h2>
                    <h1 className="i-name">Alex</h1>
                    <div className="i-title">
                        <div className="i-title-wrapper">
                            <div className="i-title-item">Web Developer</div>
                            <div className="i-title-item">Guitarrist</div>
                            <div className="i-title-item">Singer</div>
                            <div className="i-title-item">Music Producer</div>
                            <div className="i-title-item">Streamer</div>
                            <div className="i-title-item">Content Creator</div>
                        </div>
                    </div>
                    <div>
                        <p className="i-desc">
                            I am a simple musician who falls in love with
                            ReactJS and NodeJS. I do streams chatting with people
                            while I play video games. Always learning, always working.
                        </p>
                    </div>

                </div>
            </div>
            <div className="i-right">
                <div className="i-bg"></div>
                <img src={yo} alt="yo" className="i-img" />
            </div>
        </div>
    )
}

export default Intro